@if (!translation && !img) {
  <div class="card card-other">
    <div class="card-background"></div>
  </div>
}

@if (translation || img) {
  <a [href]="link" class="card card-other">
    <div class="card-background" [lazyLoad]="img"></div>
    <div class="card-body">
      @if (translation) {
        <div class="card-sub-title">
          {{ 'banners.view_more' | transloco }}
        </div>
      }
      @if (translation) {
        <div class="card-title dot">
          <span>{{ 'banners.' + translation | transloco }}</span>
        </div>
      }
    </div>
  </a>
}
